import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import O2img from "../assets/kangaroo/O2image.png"
import a1hovermobile from "../assets/kangaroo/A1hovermobile.png"
import nhovermobile from "../assets/kangaroo/Nmobilehover.png"
import ghovermobile from "../assets/kangaroo/Ghovermobile.png"
import bgImage from "../assets/kangaroo/bg_icon.svg";
import Khoverimg from "../assets/kangaroo/KcomponentMobileHover.png";
import "./Component/Homepage.css";
import logo from "../assets/kangaroo/logo.svg";
import Kcomponent from "./Component/Kcomponent";
import MainComponent from "./Component/MainComponent";

import AustralianSVG2 from "../Homepage/Component/AustrialianSVG";
import { AnimatePresence, motion } from "framer-motion";
import newImg from "../assets/kangaroo/newhover.png";
import aus2Umg from "../assets/kangaroo/a2hover.png";
import rImg from "../assets/kangaroo/rhover.png";
import O1img from "../assets/kangaroo/O1hover.png";
import { isObjectLike } from "lodash";
import Ncomponent from "./Component/Ncomponent";
import A2component from "./Component/A2component";
import Gcomponent from "./Component/Gcomponent";
import Rcomponent from "./Component/Rcomponent";

import SmallPage from "./SmallPage";
import Professional from "./Professional";
import SectionContainer from "./SectionContainer";
import SmartPreparation from "./SmartPreparation";
import Explore from "./Explore";
import Review from "./Review";
import Map from "./Map";
import O1component from "./Component/O1component";
import O2component from "./Component/O2component";
import LearnMore from "./LearnMore";
import DestinationSelect from "./DestinationSelect";
import JoinSuccess from "./JoinSuccess";
import AustralianSVG from "../Homepage/Component/AustrialianSVG";
import { useQuery } from "@tanstack/react-query";
import _BaseAPIService from "../services/_BaseAPIService";
import Destinationcountry from "../services/Destinationcountry";
import HomeSectionService from "../services/HomeSectionService";
import SVGService from "../services/SvgAnimationService";
import { imageBaseApi } from "../services/imageBaseApi";
import { useNavigate } from "react-router-dom";

const Homepage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedComponent, setSelectedComponent] = useState(null);
  const [animationDone, setAnimationDone] = useState(false);
  const [hoveredLetter, setHoveredLetter] = useState(null);
  const [hoveredElement, setHoveredElement] = useState(null);
  const [childHovered, setChildHovered] = useState(false);
  const [animationDone1, setAnimationDone1] = useState({
    K: false,
    A1: false,
    N: false,
    G: false,
    A2: false,
    R: false,
    O1: false,
    O2: false,
  });
  const router = useNavigate()

  const contentHeight = 340;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);


  const o2Variants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.3, ease: "easeInOut", delay: 0.3 } // only for hover-in
    },
    exit: {
      opacity: 0,
      scale: 0.95,
      transition: { duration: 0.3, ease: "easeInOut" } // no delay for hover-out
    }
  };
  // Update isMobile on window resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Handle animation complete for specific letter
  const handleAnimationComplete = (letter) => {
    setAnimationDone1((prev) => ({ ...prev, [letter]: true }));
  };

  const fetchData = async () => {
    const response = await HomeSectionService.getList();

  }


  const originalColors = {
    K: "#7E1790",
    A1: "#FF4D1D",
    N: "#AEF611",
    G: "#0FEDED",
    A2: "#1900DA",
    R: "#D70A84",
    O1: "#EA381D",
    O2: "#7A0708",
    dim: "#d6dced",
  };

  const allElements = document.querySelectorAll('svg [class^="st"]');
  const reDraw = (letter) => {
    // Get all st* elements fresh each time

    allElements.forEach((el) => {
      if (letter === null) {
        // Restore all original fills if no hover
        el.style.fill = el.getAttribute("fill");
      } else {
        // Dim all except the hovered element
        if (el.id === letter) {
          el.style.fill = el.getAttribute("fill"); // restore hovered
        } else {
          el.style.fill = originalColors.dim; // dim others
        }
      }
    });
  };


  useEffect(() => {
    reDraw(hoveredLetter);
  }, [hoveredLetter]);



  const [countrydata, setCountrydata] = useState([])

  const fetchCountryData = async () => {
    try {
      const response = await HomeSectionService.getList();
      setCountrydata(response)
    } catch (error) {

      return null;
    }
  };

  const fetchBannerData = async () => {
    const response = await SVGService.getList();
    return response
  }

  const { isPending, error, data: bannerData } = useQuery({
    queryKey: ["bannerData"],
    queryFn: fetchBannerData,
  })



  useEffect(() => {
    fetchCountryData();
  }, []);



  const filterMain = bannerData?.filter((item) => item?.slug === "start-smart")
  const filterK = bannerData?.filter((item) => item?.slug === "study-uk")

  const filterA1 = bannerData?.filter((item) => item?.slug === "study-australia")

  const filterN = bannerData?.filter((item) => item?.slug === "study-new-zealand")
  const filterG = bannerData?.filter((item) => item?.slug === "guided-study-journey")
  const filterA2 = bannerData?.filter((item) => item?.slug === "study-canada")
  const filterR = bannerData?.filter((item) => item?.slug === "test-preparation")
  const filterO1 = bannerData?.filter((item) => item?.slug === "study-usa")
  const filterO2 = bannerData?.filter((item) => item?.slug === "study-abroad-process")

  const filterDiscover = countrydata.filter((item) => item?.slug === "guided-students-success")
  const filterEmpower = countrydata.filter((item) => item?.slug === "about-kef")
  const filterJourney = countrydata.filter((item) => item?.slug === "global-destinations")
  const filterTest = countrydata.filter((item) => item?.slug === "test-preparation")
  console.log("hoveredLetter", hoveredLetter)

  const [showMain, setShowMain] = useState(true);

  useEffect(() => {
    let timer;

    if (hoveredLetter === null) {
      timer = setTimeout(() => {
        setShowMain(true);
      }, 0); // 0.5 sec
    } else {
      setShowMain(false);
    }

    return () => clearTimeout(timer);
  }, [hoveredLetter]);

  return (
    <div style={{ overflowX: "hidden" }} className="py-4">
    
      {/* <Container fluid className=" position-relative" style={{ background: "linear-gradient(to left, #e3e2e8, #f9f9fb)", marginBottom: "8rem" }}>
        <div
          style={{
            width: 'clamp(4rem, 12vw, 8rem)',
            height: 'clamp(4.4rem, 13.2vw, 10rem)',
            background: 'linear-gradient(to right, #7e1790, #d70a84)',
            clipPath: 'polygon(0 0, 100% 50%, 0 100%)',
            filter: 'drop-shadow(0 0 clamp(10px, 2vw, 20px) rgba(137, 2, 149, 0.3))',
            position: 'absolute',
            left: -6,
            top: isMobile ? '42%' : '50%',
            transform: 'translateY(-50%)',
            zIndex: 1
          }}
        ></div>
        <Container className="h-100" fluid style={{ width: "1509px" }}>
          <JoinSuccess data={filterDiscover} />
        </Container>
      </Container> */}
      {/* <SectionContainer mainId="Page3">
        <LearnMore data={filterEmpower} />
        <hr className="line" />
      </SectionContainer> */}
      {/* <SectionContainer mainId="Page4">
        <DestinationSelect data={filterJourney} />
        <hr className="line" />
      </SectionContainer> */}
      {/* <SectionContainer mainId="Page5">
        <SmartPreparation data={filterTest} />
        <hr className="line" />
      </SectionContainer> */}
      <SectionContainer mainId="Page6">
        <Explore />
      </SectionContainer>
      {/* <SectionContainer mainId="SmallPage">
        <SmallPage />
      </SectionContainer>
      <SectionContainer mainId="Page7">
        <Review />
        <hr className="line" />
      </SectionContainer>
      <SectionContainer mainId="Page8">
        <Map />
        <hr className="line" />
      </SectionContainer>
      <SectionContainer mainId="Professional">
        <Professional />
      </SectionContainer> */}
      {/* <SectionContainer mainId="Page11">
        <Page11 />
        </SectionContainer> */}

    </div>
  );
};

export default Homepage;
